import { http } from './http'
import { auth } from './auth'
import { z } from 'zod'
import { AgendaNoteSchema } from '../schemas'
import { parseWithZod } from '../utils/parse-with-zod'
import { CreateNotePayload } from '../types'

export const agendaNotes = {
  createNote: async (payload: CreateNotePayload, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(`${regionHost}/api/agenda_notes`, payload, dealId)
    return parseWithZod(z.object({ agenda_note: AgendaNoteSchema }), result).agenda_note
  },

  editNoteBody: async (
    id: number,
    payload: {
      body: string
    },
    dealId: number,
  ) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(
      `${regionHost}/api/agenda_notes/${id}/edit_body`,
      payload,
      dealId,
    )
    return parseWithZod(z.object({ agenda_note: AgendaNoteSchema }), result).agenda_note
  },

  deleteNote: async (id: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    await http.delete(`${regionHost}/api/agenda_notes/${id}`, dealId)
  },

  resolveNote: async (id: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(`${regionHost}/api/agenda_notes/${id}/resolve`, {}, dealId)
    return parseWithZod(z.object({ agenda_note: AgendaNoteSchema }), result).agenda_note
  },

  unresolveNote: async (id: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(`${regionHost}/api/agenda_notes/${id}/unresolve`, {}, dealId)
    return parseWithZod(z.object({ agenda_note: AgendaNoteSchema }), result).agenda_note
  },
}
